import React from "react"
import { Alert, Card, CardContent, Container, Dialog, DialogTitle, Divider, Snackbar, Grid, Typography } from "@mui/material"
import { Formik } from "formik"
import { ActionButton, SnackBarHideDuration, SnackBarTransition } from "../../../utils/ui_utils"

function FileImportDialog({
    initialValue,
    visible,
    onClose,
    okSubmit,
    snackbarClose,
    counterGroupMsg,
    countersMsg,
    itemsMsg,
    counterGroupIcon,
    countersIcon,
    itemsIcon,
    submitDisabled,
    snackbarStatus,
    snackbarMsg,
    snackbarSeverity
}) {

    if (initialValue == undefined)
        initialValue = {
            name: '',
        }

    const handleSnackbarClose = () => {
        snackbarClose()
    }

    const handleSubmit = async (value, { resetForm, setErrors, setStatus, setSubmitting }) => {
        okSubmit()
        onClose();
    }

    return (
        <>
            <Dialog maxWidth={'sm'} fullWidth anchor="right" backdrop="static" variant="temporary" open={visible}>
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    Import File Status
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        onSubmit={handleSubmit}
                        initialValues={initialValue}
                    >
                        {({
                            handleSubmit,
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card >
                                    <CardContent>
                                        <Grid container spacing={5} style={{ paddingTop: 10, paddingLeft: 10 }}>
                                            <Grid item>
                                                {counterGroupMsg && <Grid container ><Grid item sx={{ marginRight: 10 }} ><Typography variant='subtitle1' gutterBottom fontWeight={'bold'}>{counterGroupMsg}</Typography></Grid><Grid item ><Typography variant='subtitle1'>{counterGroupIcon}</Typography></Grid></Grid>}
                                                {countersMsg && <Grid container sx={{ justifyContent: "space-between" }}><Grid item ><Typography variant='subtitle1' gutterBottom fontWeight={'bold'}>{countersMsg}</Typography></Grid><Grid item ><Typography variant='subtitle1'>{countersIcon}</Typography></Grid></Grid>}
                                                {itemsMsg && <Grid container sx={{ justifyContent: "space-between" }}><Grid item ><Typography variant='subtitle1' gutterBottom fontWeight={'bold'}>{itemsMsg}</Typography></Grid><Grid item ><Typography variant='subtitle1'>{itemsIcon}</Typography></Grid></Grid>}
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item>
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8} disabled={submitDisabled} >
                                            Ok
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
            <div>
                <Snackbar
                    open={snackbarStatus}
                    autoHideDuration={SnackBarHideDuration}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    onClose={handleSnackbarClose}
                    TransitionComponent={SnackBarTransition}
                >
                    <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
                        {snackbarMsg}
                    </Alert>
                </Snackbar>
            </div>
        </>
    )
}

export default FileImportDialog